import { render, staticRenderFns } from "./DesgloseISR.vue?vue&type=template&id=5aae5b99&scoped=true"
import script from "./DesgloseISR.vue?vue&type=script&lang=js"
export * from "./DesgloseISR.vue?vue&type=script&lang=js"
import style0 from "./DesgloseISR.vue?vue&type=style&index=0&id=5aae5b99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aae5b99",
  null
  
)

export default component.exports